import FilterInputItems from "../shared/Filter/FilterInputItems";
import {tableContentType} from "../shared/table/table_utils";

export const agentGroupConstants = {
  filters : [
    FilterInputItems.id,
    FilterInputItems.title,
    FilterInputItems.status,
  ],
  listAttributes : [
    {
      title: 'ID',
      field: 'id',
      type: tableContentType.ID,
    },
    {
      title: 'Name',
      field: 'name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Email',
      field: 'email',
      type: tableContentType.TEXT,
    },
    {
      title: 'Location',
      field: 'location',
      type: tableContentType.TEXT,
    },
    {
      title: 'Area Name',
      field: 'area_name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Status',
      field: 'status',
      type: tableContentType.STATUS,
    },
    {
      title: 'Action',
      field: 'action',
      type: tableContentType.ACTION,
    },
  ],
  detailsAttributes : [
    {
      title: 'ID',
      field: 'id',
      type: tableContentType.TEXT,
    },
    {
      title: 'Name',
      field: 'name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Email',
      field: 'email',
      type: tableContentType.TEXT,
    },
    {
      title: 'Location',
      field: 'location',
      type: tableContentType.TEXT,
    },
    {
      title: 'Area Name',
      field: 'area_name',
      type: tableContentType.TEXT,
    },
    {
      title: 'Status',
      field: 'status',
      type: tableContentType.STATUS,
    },
    {
      title: 'Created At',
      field: 'created_at',
      type: tableContentType.DATE_TIME,
    },
  ],
};

